import React from "react";
import { useParams } from "react-router-dom";
import Student12TopMenu from "../studentInfo/student12topmenu"
import GlobalBragSheet from "../../pages/common/globalbragsheet";
import { useAuth } from "../../../usercontext";
import PageNotes from "../../pages/common/pagenotesnew";

export default function InstructorStudentBragSheet() {
  const { profile, setProfile } = useAuth();
  let { slug } = useParams();

  return (
    <>
    <Student12TopMenu slug={slug} activeMenu={"BragSheet"} />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
          <PageNotes
              type={"Instructor"}
              pageName={"BragSheet"}
              studentId={slug}
              instructorId={profile.id}
            />
            <GlobalBragSheet slug={slug} />
          </div>
        </div>
      </div>
    </>
  );
}
